<button (click)="loginWithGoogle()" class="btn btn-outline-dark fw-bold w-50">
  <i class="bi bi-google text-google"></i>
  Continuar con Google
</button>
